import { useEffect, useRef } from 'react';

import { useCurrentSite } from '../../providers/currentSite/useCurrentSite';

const SCRIPT_ID = 'trustpilot-widget-script';

type TrustpilotMiniTrustScoreWidgetProps = {
    textColor?: string;
    theme?: 'light' | 'dark';
};

export function TrustpilotMiniTrustScoreWidget({
    textColor = '#1f2226',
    theme = 'light',
}: TrustpilotMiniTrustScoreWidgetProps) {
    const { currentSite } = useCurrentSite();
    const { locale, trustpilot } = currentSite;
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (trustpilot && !document.getElementById(SCRIPT_ID)) {
            const script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
            script.async = true;
            document.head.appendChild(script);
        }
    }, [trustpilot]);

    useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    if (!trustpilot) {
        return null;
    }

    return (
        <div
            ref={ref}
            className="trustpilot-widget"
            data-locale={locale}
            data-template-id="53aa8807dec7e10d38f59f32"
            data-businessunit-id={trustpilot.businessUnitId}
            data-style-height="100%"
            data-style-width="100%"
            data-token={trustpilot.token}
            data-theme={theme}
            data-text-color={textColor}
        >
            <a
                href={`${trustpilot.url}${trustpilot.reviewPath}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                Trustpilot
            </a>
        </div>
    );
}
